import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function PrivateRoute(props) {
  return (
    <>
      {Cookies.get("test_engine_token") ? (
        props.children
      ) : (
        <Navigate
          to={
            Cookies.get("test_engine_project")
              ? `/${Cookies.get("test_engine_project")}/login`
              : "/login"
          }
        />
      )}
    </>
  );
}
